"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var imDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createIm: _factoriesAny.createIm
};
exports.imDependencies = imDependencies;